__webpack_require__.p = "https://static.age.awaze.com/landing-pages-mfe/013d12c/_next/";